import React, { useEffect, useState } from "react";

import Select from "react-select";
import DateRange2 from "../../Component/DateRange/DateRange2";

import { get, post } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import { Toast } from "../../Component/Toast";
import useStoreKv from "../redux/store/useStorekv";
import { useNavigate } from "react-router-dom";

const AnnounceResult = () => {

  const { kv, set } = useStoreKv();
  const [lotDraw, setLotDraw] = useState("");

  const DEFAULT_LOT_OPTIONS = [
    { value: "Dear", label: "Dear" },
    { value: "Kerala", label: "Kerala" },
  ];


  const DEFAULT_TIME_OPTIONS_DEAR = [
    { value: "1 PM", label: "1 PM", game_id: 1 },
    { value: "6 PM", label: "6 PM", game_id: 3 },
    { value: "8 PM", label: "8 PM", game_id: 4 },
  ];

  const DEFAULT_TIME_OPTIONS_KERALA = [
    { value: "3 PM", label: "3 PM", game_id: 2 },
  ];

  const [timeDraw, setTimeDraw] = useState(null);
  const [resultNumber, setResultNumber] = useState(["", "", "", ""]);
  const [drawDate, setDrawDate] = useState(new Date().toISOString().split("T")[0]);
  const [popup, setPopup] = useState(false);
  const [showResult, setShowResult] = useState(false);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const [timeOptions, setTimeOptions] = useState([]);
  const [lotOptions, setLotOptions] = useState(kv.lotOptions || DEFAULT_LOT_OPTIONS);
  const [selectedTimeId, setSelectedTimeId] = useState(null);

  const [selectedLotData, setSelectedLotData] = useState([]);
  const [gameId, setGameId] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (!lotDraw) return;

    setTimeOptions(
      lotDraw?.value === 'Kerala'
        ? DEFAULT_TIME_OPTIONS_KERALA
        : DEFAULT_TIME_OPTIONS_DEAR
    );
  }, [lotDraw]);


//   console.log("lotDrawcccc", lotDraw);


  // ⭐ Backup data for Edit
  const [backupData, setBackupData] = useState(null);

//   console.log("backupData", backupData);


  const getList = async () => {
    if (!drawDate) return;

    try {
      const res = await get(`${URLS.REPORTDRAW}?date=${drawDate}`);

      if (res?.status === "success" && res?.data) {
        const data = res.data;
        let formatted = [];
        setSelectedLotData(data);

        if (data.some(i => i.name.toLowerCase().startsWith("dear"))) {
          formatted.push({ value: "Dear", label: "Dear" });
        }

        if (data.some(i => i.name.toLowerCase() === "kerala")) {
          formatted.push({ value: "Kerala", label: "Kerala" });
        }


        setLotOptions(formatted);
        set('lotOptions', formatted);
        if (formatted.length === 1) setLotDraw(formatted[0]);
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    getList();
  }, [drawDate]);

  useEffect(() => {
    if (!lotDraw?.value) {
      setTimeOptions([]);
      return;
    }

    const fetchTimes = async () => {
      try {
        if (!selectedLotData || selectedLotData.length === 0) {
          setTimeOptions(lotDraw?.value === 'Kerala' ? DEFAULT_TIME_OPTIONS_KERALA : DEFAULT_TIME_OPTIONS_DEAR);
          set('lotTimeOptions', lotDraw?.value === 'Kerala' ? DEFAULT_TIME_OPTIONS_KERALA : DEFAULT_TIME_OPTIONS_DEAR);
          return;
        }

        const lowerLot = lotDraw.value?.toLowerCase();
        const filtered = selectedLotData
          .filter((item) => {
            const name = item.name.toLowerCase();

            if (lowerLot === "dear") return name.startsWith("dear");
            if (lowerLot === "kerala") return name.includes("kerala");
            return false;
          })
          .map((item) => ({
            value: item.lot_time,
            label: item.lot_time,
            id: item.id,
            game_id: item.game_id,
          }));

        if (filtered.length > 0) {
          setTimeOptions(filtered);
          set('lotTimeOptions', filtered);
        } else {
          setTimeOptions(lotDraw?.value === 'Kerala' ? DEFAULT_TIME_OPTIONS_KERALA : DEFAULT_TIME_OPTIONS_DEAR);
          set('lotTimeOptions', lotDraw?.value === 'Kerala' ? DEFAULT_TIME_OPTIONS_KERALA : DEFAULT_TIME_OPTIONS_DEAR);
        }
//         console.log("Filtered Time Options:", filtered);
      } catch (err) {
        console.error(err);
      }
    };

    fetchTimes();
  }, [lotDraw, drawDate, selectedLotData]);

  const handleChange = (e) => {
    const value = e.target.value.replace(/\D/g, "").slice(0, 4);
    const arr = value.split("");
    while (arr.length < 4) arr.push("");
    setResultNumber(arr);
  };

  const handleCheckResult = () => {
    let newErrors = {};

    if (!lotDraw) newErrors.lot = "Please select Lot Name";
    if (!timeDraw) newErrors.time = "Please select Time";
    if (resultNumber.join("").length !== 4)
      newErrors.resultNumber = "Please enter 4 digits";

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      setShowResult(false);
      return;
    }

    // ⭐ Save backup before clearing
    setBackupData({
      drawDate,
      lotDraw,
      timeDraw,
      resultNumber,
    });

    setShowResult(true);

    // ⭐ Clear fields for UI reset
    setDrawDate(null);
    setLotDraw("");
    setResultNumber(["", "", "", ""]);
    setTimeDraw(null);
  };

  const handleEdit = () => {
    if (!backupData) return;

    // ⭐ Restore backup data
    setDrawDate(backupData.drawDate);
    setLotDraw(backupData.lotDraw);
    setTimeDraw(backupData.timeDraw);
    setResultNumber(backupData.resultNumber);

    setShowResult(false);
  };

//   console.log("resultNumber", resultNumber);


  const handleAnnounceResult = async () => {

    const postId = selectedLotData.find(
      item => item.game_id === gameId
    )?.id;

    const id = selectedTimeId || postId;

    const postData = {
      id: id,
      winning_number: backupData?.resultNumber.join("")
    }

    setLoading(true);
    const res = await post(URLS.RESULTANNOUNCE, postData);

    if (res.status === "success") {
      Toast(res.message || "Result Announced Successfully");
      setDrawDate(null);
      setLotDraw("");
      setShowResult(false);
      setResultNumber(["", "", "", ""]);
      setTimeDraw(null);
      setPopup(false);
      navigate("/overall-result");
    }
    setLoading(false);
  }

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderRadius: 8,
      border: "1px solid #00474366",
      border: `1px solid ${state.isFocused || state.hasValue ? "#004743" : "#00474366"}`,
      boxShadow: state.isFocused
        ? "transparent"
        : "0 0 0 1px #dffffd66",
      "&:hover": {
        border: "1px solid #00474366",
      },
      backgroundColor: "#F0EDE6",
      minHeight: 51,
      padding: "3px 10px",
      fontFamily: state.isSelected ? "f3" : "f2",
      color: "#000",
    }),

    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
      backgroundColor: "#F0EDE6",
      borderRadius: 8,
    }),

    menuList: (provided) => ({
      ...provided,
      backgroundColor: "#F0EDE6",
      borderRadius: 8,
    }),

    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "transparent"
        : state.isFocused
          ? "transparent"
          : "transparent",
      color: state.isSelected
        ? "#00211fff"
        : "#004743",
      cursor: "pointer",
      ":active": {
        backgroundColor: "#00474333",
      },
    }),

    singleValue: (provided) => ({
      ...provided,
      color: "#004743",
    }),

    indicatorSeparator: () => ({
      display: "none",
    }),

    dropdownIndicator: (provided) => ({
      ...provided,
      color: "#004743",
      "&:hover": {
        color: "#004743",
      },
    }),
  };


  return (
    <div className="dashRightView ">
      <div style={{ paddingTop: 0 }} className="container_overall">

        <div className="announcement_date mb-3 col-md-5">
          <DateRange2 selectedDate={drawDate} setSelectedDate={setDrawDate} />
        </div>

        {/* LOT */}
        <div className="my-2 pb-2 col-md-5">
          <label className="form-label f2 fs-md-14 fs-lg-16 m-0 primary1">Lot Name</label>
          <Select
            className="location-search"
            options={lotOptions}
            value={lotDraw}
            onChange={(selected) => {
              setLotDraw(selected);
              setTimeDraw(null);
              setSelectedTimeId(null);
            }}
            placeholder="Select Lot"
            isDisabled={!drawDate}
            styles={customStyles}
            isSearchable={false}
            noOptionsMessage={() => ""}
          />
          {errors.lot && <p className="err">{errors.lot}</p>}
        </div>

        {/* TIME */}
        <div className="my-2 pb-2 col-md-5">
          <label className="form-label f2 fs-md-14 fs-lg-16 m-0 primary1">Time</label>
          <Select
            className="location-search"
            value={timeDraw}
            onChange={(selected) => {
              setTimeDraw(selected);
              setSelectedTimeId(selected.id);
              setGameId(selected.game_id);
            }}
            options={timeOptions}
            isDisabled={!lotDraw}
            placeholder="Select Time"
            styles={customStyles}
            isSearchable={false}
            noOptionsMessage={() => ""}
          />
          {errors.time && <p className="err">{errors.time}</p>}
        </div>

        {/* RESULT NUMBER */}
        <div className="my-2 pb-2 col-md-5">
          <label className="form-label f2 fs-md-14 fs-lg-16 m-0 primary1">Result Number</label>
          <input
            className="input-box placholdercolorchanges2"
            type="number"
            value={resultNumber.join("")}
            onChange={handleChange}
            maxLength={4}
            placeholder="Enter Result Number"
          />
          {errors.resultNumber && <p className="err">{errors.resultNumber}</p>}
        </div>

        <div className="my-3 col-md-5">
          <button className="add-button f3 w-100 fs-xs-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 white" onClick={handleCheckResult}>
            Check Result
          </button>
        </div>

        {/* PREVIEW BOX */}
        {showResult && (
          <div className=" col-md-5">
            <div className="d-flex ac-jb">
              <label className="form-label f3 fs-md-14 fs-lg-16 m-0 primary">Check Result</label>
              <button className="edit1-btn" onClick={handleEdit}>Edit</button>
            </div>

            <div className="check_result my-2">
              <div className="d-flex ac-jb my-2">
                <p className="f3">Date</p>
                <p className="f2 gray">
                  {new Date(backupData?.drawDate)
                    .toLocaleDateString("en-GB")
                    .replace(/\//g, "-")}
                </p>
              </div>

              <div className="d-flex ac-jb my-2">
                <p className="f3">Lot Name</p>
                <p className="f2 gray">{backupData?.lotDraw?.label}</p>
              </div>

              <div className="d-flex ac-jb my-2">
                <p className="f3">Time</p>
                <p className="f2 gray">{backupData?.timeDraw?.label}</p>
              </div>

              <div className="d-flex ac-jb">
                <p className="f3">Result Number</p>
                <div className="d-flex gap-2">
                  {backupData?.resultNumber?.map((n, i) => (
                    <input
                      key={i}
                      value={n}
                      readOnly
                      className="result-input placholdercolorchanges2"
                    />
                  ))}
                </div>
              </div>
            </div>

            <button
              style={{ marginBottom: 80, marginTop: 20 }}
              onClick={() => setPopup(true)}
              className="add-button f3 w-100 fs-xs-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 white"
            >
              Announce Result
            </button>
          </div>
        )}
      </div>
      {popup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <p className="f3 fs-xs-14 fs-sm-15 fs-md-15 fs-lg-15 fs-xl-17 fs-xxl-19 primary">
              Are you sure you want to Announce Result?
            </p>
            <div style={{ paddingTop: 20 }} className="d-flex ac-jb px-2 f3 fs-xs-14 fs-sm-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19">
              <button onClick={() => { setPopup(false) }} className="no-btn w-40">
                No
              </button>
              <button
                onClick={handleAnnounceResult}
                className="yes-btn f2 w-40 f3 fs-xs-14 fs-sm-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19"
              >
                {loading ? <>
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                    style={{ color: "white" }}
                  ></span>
                </> : 'Yes'}

              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AnnounceResult;
